import { render, staticRenderFns } from "./FfvlLayer.vue?vue&type=template&id=0b2ead7f&scoped=true"
import script from "./FfvlLayer.vue?vue&type=script&lang=js"
export * from "./FfvlLayer.vue?vue&type=script&lang=js"
import style0 from "./FfvlLayer.vue?vue&type=style&index=0&id=0b2ead7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ead7f",
  null
  
)

export default component.exports